export default __webpack_public_path__ + "static/media/Ahsan.12047518.png";